const customers = {
  firestorePath: '/customers',
  firestoreRefType: 'collection',
  moduleName: 'customers',
  statePropName: 'customers',
  namespaced: true,
  serverChange: {
    convertTimestamps: {
      created_at: '%convertTimestamp%', // default
      updated_at: '%convertTimestamp%', // default
    },
  },

  state: {
    customers: null,
  },
  getters: {
    getCustomers: (state) => {
      return _.toArray(state.customers);
    },
    getCustomersDataTable: (state,getters,rootState,rootGetters) => {
      return _.toArray(state.customers).map(customer => {
          return {
          ...customer,
            vacancies:rootGetters['vacancies/getVacanciesFromCustomer'](customer.id),
            placements: rootGetters['placements/getPlacementsFromCustomer'](customer.id)
          }});
    },
    getCustomer: (state) => (id) => {
      return state.customers[id] ? state.customers[id] : null
    },
    getAvailableCustomersPerCandidate: (state, getters, rootState, rootGetters) => (id) => {
      let placements = rootGetters['placements/getPlacements'];
      let customers = _.toArray(state.customers);

      var filteredPlacements = _.filter(placements, {'endDate': '', 'candidateId': id});
      var removedCustomers = [];

      if (filteredPlacements.length === 0) {
        return customers
      } else {
        for (var p = 0; p < filteredPlacements.length; p++) {
          removedCustomers = _.remove(customers, {
            id: filteredPlacements[p].customerId
          });
        }
      }
      return _.difference(customers, removedCustomers);
    }

  },
  mutations: {},
  actions: {},
}

export default customers